'use client';

import { PropsWithChildren, useEffect, useState } from 'react';

import { isMswEnabled } from './config';

/**
 * MSW 부팅이 끝날 때까지 children 렌더를 보류해, 목킹 전에 실 API 로 요청이 새는 것을 막는다.
 *
 * 이 게이트는 로컬 개발 빌드에서만 켠다. 배포 빌드에서 켜면 이 컴포넌트가 앱 트리 전체를
 * 감싸고 있는 탓에 SSR 결과가 통째로 비고, JSON-LD 와 본문이 원본 HTML 에 남지 않는다.
 * 그러면 JS 를 실행하지 않는 크롤러(GPTBot, ClaudeBot, PerplexityBot, Naver Yeti 등)가
 * 빈 문서를 받는다 — robots.txt 로 AI 크롤러를 허용한 의도가 무효화된다.
 */
const GATE_ENABLED = process.env.NODE_ENV === 'development';

export function MockingProvider({ children }: PropsWithChildren) {
  const [ready, setReady] = useState(!GATE_ENABLED);

  useEffect(() => {
    if (!GATE_ENABLED) return;

    let cancelled = false;
    (async () => {
      // localStorage는 브라우저에서만 유효 → 첫 렌더는 env 값, 이후 effect에서 확정.
      if (isMswEnabled()) {
        const { worker } = await import('./browser');
        await worker.start({
          onUnhandledRequest: 'bypass',
          serviceWorker: { url: '/mockServiceWorker.js' },
        });
      }
      if (!cancelled) setReady(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) return null;
  return <>{children}</>;
}
